export enum LicenseType {
  MaxStorage = 'MaxStorage',
  FreeTier = 'MaxStorage_FreeTier',
}

export enum LicenseStatus {
  Active = 'Active',
  Inactive = 'Inactive',
  Expired = 'Expired',
  Disabled = 'Disabled',
  Deleted = 'Deleted',
  Obsoleted = 'Obsoleted',
}

export interface License {
  skuName: string;
  type: LicenseType;
  startDate: Date;
  endDate?: Date;
  quota: number;
  status: LicenseStatus;
}
